const escLocale = {
  esc: {
    mandatoryInstallation: "Mandatory installation",
    mandatoryInstallationDesc: "The site requires a mandatory installation",
    cardTitle: "Acquisition status",
    modalTitle: "ESC Quote",
    modalActionStep:
      "You are about to start the ESC quote signing process for this site. Please verify the site's eligibility. A quote will be generated and sent by email to the subscriber.",
    modalSignStep:
      "You should have received the quote confirming the device is free of charge by email. We will validate it together using the code received by SMS.",
    modalSignStepGoToYousign: "Open Yousign",
    otherAction: "I want to perform another action",
    startSignature: "Start signature",
    checkSignature: "I confirm the signature",
    withdrawalPeriod: "Withdrawal period",
    interAllowedFrom: "Intervention authorized from:",
    periodReached: "Period reached",
    warnings: {
      globalEscWarning: "AN ESC QUOTE NEEDS TO BE SIGNED FOR THIS SITE",
      hasNoElectricityBill: "An electricity bill is expected for this site",
      someElectricityBillsHaveUncontrolledState: "One or more electricity bills are pending validation",
      allElectricityBillsHaveOcrFailed:
        "The uploaded electricity bills were not deemed compliant. A compliant electricity bill is expected for this site",
      noneElectricityBillHaveOcrSuccess:
        "Unable to analyze the electricity bills. The provided documents could not be automatically recognized by the OCR.",
      someElectricityBillHaveOcrFailed: "Some electricity bills could not be automatically recognized by the OCR.",
      documentIsNotSignedYet: "The document is not signed yet",
      escQuoteInProgressButNotSigned: "ESC quote in progress but not signed, please resume the signature process",
      subscriberEligible: "Member eligible for the ESC bonus, please resume the signature process",
      incorrectFields: "Some fields are not compatible with ESC eligibility",
      fields: {
        surface: "Invalid surface area",
        subscriber: "Missing member",
        subscriberCompany: "The site is a commercial/tertiary site",
        mandatoryInstallation: "The site requires a mandatory installation",
        isNotInFrance: "The site is not located in mainland France.",
      },
    },
    toasts: {
      quoteSentSuccess: "The quote has been sent to the member by email",
      quoteSentError: "An error occurred while generating the quote",
    },
    escEligibility: "ESC Eligible",
    escQuoteSigned: "ESC Quote Signed",
    continueFlow: "Resume process",
    generateQuote: "Generate a quote",
    restartQuoteProcess: "Restart the quote signature process",
    // Folder details view
    generalInformation: "General information about the ESC file",
    escStatus: "ESC Status",
    escStatusEligible: "ESC Eligible",
    escStatusNonEligible: "Non-ESC Eligible",
    escStatusNotDetermined: "Status Not Determined",
    phase: "Phase",
    escVersionLabel: "Information on ESC version",
    escVersionTooltip: "Indicates the ESC phase/iteration of the file.",
    engagementDateLabel: "Information on engagement date",
    engagementDateTooltip: "Official engagement date of the ESC file with the certifying body.",
    escTypes: "ESC Types",
    escTypesInfo: "Information on ESC types",
    escTypesDescription: "List of active ESC standardized operation sheets for this file.",
    noEscTypesProvided: "No types provided",
    folderProgress: "File progress",
    folderActions: "Available actions on the file",
    actionsHistory: "Action history",
    displayMode: "Display mode",
    displayModeList: "List",
    displayModeHierarchy: "Hierarchy",
    applications: "Applications",
    allApplications: "All",
    actors: "Actors",
    allActors: "All",
    clearFilters: "Reset",
    noEventsMatched: "No events match the selected filters.",
    folderLoadError: "Error loading ESC file",
    noFolderAvailable: "No ESC file available for this site",
    selectedCount: "{count} application | {count} applications",
    selectedActorCount: "{count} actor | {count} actors",
    eventDetails: "View details",
    eventDetailsKeys: "{count} key | {count} keys",
    system: "System",
    systemAction: "System action",
    userId: "ID: {id}",
    user: "User",
    userWithId: "User {id}",
    systemLabel: "System",
    systemTooltip: "System action",
    userLabel: "User {id}",
    userIdTooltip: "ID: {id}",
    profileLabel: "Profile",
    idLabel: "ID",
    // Action type labels
    actionTypeCaseMigration: "Case migration",
    actionTypeCreated: "Case created",
    actionTypeEligibilityCheck: "Eligibility check",
    actionTypeGenerateEstimate: "Generate estimate",
    actionTypeGenerateInvoice: "Generate invoice",
    actionTypeSendReminder: "Send reminder",
    actionTypeGenerateEscInstallationPackage: "ESC installation package",
    actionTypeGenerateInstallationPackage: "Installation package",
    actionTypeGenerateMaintenancePackage: "Maintenance package",
    actionTypeGenerateTransferForm: "Generate transfer form",
    actionTypeGenerateCustomerServiceCertificate: "Generate customer service certificate",
    actionTypeCancelSignature: "Cancel signature",
    actionTypeCancelAllSignatures: "Cancel all signatures",
    actionTypeRegenerateDocument: "Regenerate document",
    actionTypeSwitchToSale: "Switch to sale",
    actionTypeError: "Error",
    actionTypeDocumentSigned: "Document signed",
    actionTypeGenerateCreditNote: "Generate credit note",
    actionTypeEndpointUsed: "Endpoint used",
    // Contextual action labels
    actionDownloadDocument: "Download document",
    actionCancelSignature: "Cancel signature",
    actionSendReminder: "Remind signer",
    actionViewDetails: "View details",
    actionViewError: "View error",
    actionRegenerateDocument: "Regenerate document",
    actionSwitchToSale: "Switch to sale",
    actionCancelAllSignatures: "Cancel all signatures",
    // Contextual action toasts
    contextualAction: {
      success: "Action executed successfully",
      error: "An error occurred while executing the action",
    },
  },
};

export default escLocale;
